import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

type UsersActionsProps = {
	className?: string;
	role: 'CLIENT' | 'MERCHANT';
	action: string;
	onAction: (value: string) => void;
};

export const UsersActions = (props: UsersActionsProps) => {
	const { t } = useTranslation();

	return (
		<article className={`flex gap-2 justify-start w-full ${props.className} `}>
			{props.role === 'MERCHANT' && (
				<Button
					htmlType='button'
					type='default'
					shape='round'
					className='text-[12px]'
					onClick={() => props.onAction('offers')}
					style={props.action === 'offers' ? { backgroundColor: '#0186ff', color: 'white', fontWeight: '600' } : {}}
				>
					{t('offers')}
				</Button>
			)}
			<Button
				htmlType='button'
				type='default'
				shape='round'
				className='text-[12px]'
				style={
					props.action === 'tradingAccount' ? { backgroundColor: '#0186ff', color: 'white', fontWeight: '600' } : {}
				}
				onClick={() => props.onAction('tradingAccount')}
			>
				{t('tradingAccount')}
			</Button>
			<Button
				htmlType='button'
				type='default'
				shape='round'
				className='text-[12px]'
				style={props.action === 'wallets' ? { backgroundColor: '#0186ff', color: 'white', fontWeight: '600' } : {}}
				onClick={() => props.onAction('wallets')}
			>
				{t('walletsAccount')}
			</Button>
		</article>
	);
};
